import { TraceDirection, TracingTaskProps } from "../../backend/types/moneyflow.ts"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { mutationHandler } from "../mutationHandler.ts"

export const trace = (payload: TracingTaskProps) => fetch(`/api/tracing/hop`, {
    method: 'POST',
    headers: {
        "Content-Type": "application/json",
        "Access-Control-Request-Method": "POST",
        "Access-Control-Request-Headers": "Content-Type"
    },
    body: JSON.stringify(payload)
})

export const startAutoTrace = (payload: TracingTaskProps) => fetch(`/api/tracing/autotrace`, {
    method: 'POST',
    headers: {
        "Content-Type": "application/json",
        "Access-Control-Request-Method": "POST",
        "Access-Control-Request-Headers": "Content-Type"
    },
    body: JSON.stringify(payload)
})

export const stopAutoTrace = (payload: {documentId: string, direction: TraceDirection}) =>
    fetch(`/api/tracing/stop_autotrace`, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Request-Method": "POST",
            "Access-Control-Request-Headers": "Content-Type"
        },
        body: JSON.stringify(payload)
    })

export const useTraceMutation = (moneyflowId: string) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: mutationHandler<{data: TracingTaskProps}, typeof trace>(trace),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [`moneyflow/${moneyflowId}`] })
            queryClient.invalidateQueries({ queryKey: [`moneyflow/${moneyflowId}/versions`] })
            queryClient.invalidateQueries({ queryKey: [`sankey-data/meta/${moneyflowId}`] })
        }
    })
}

export const useStartAutoTraceMutation = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: mutationHandler<{data: TracingTaskProps}, typeof startAutoTrace>(startAutoTrace),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['task'] })

    })
}

export const useStopAutoTraceMutation = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: mutationHandler<unknown, typeof stopAutoTrace>(stopAutoTrace),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['task'] })
    })
}
